<template>
    <div>
      <div class="center" v-if="showLoading">
        <lottie :options="defaultOptionsSplashScreen" :height="300" :width="300" v-on:animCreated="handleAnimationSplashScreen"/>
      </div>
      <div class="spin" v-else>
          <div style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px;"> 
              <div>
                  <img
                  src="../assets/images/logo2.png"
                  loading="lazy"
                  style="height:100px;"
                  />
              </div>
              <div style="display: flex; flex: 1; align-items: center; flex-end; justify-content: flex-end;">
                  <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <img src="../assets/images/coin.png" width="22" alt="Coin" />
                  <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
                </div>
                <span class="avatar" id="avatar" :style="{ 'background-image': `url(${pictureUrl})` }"></span>
              </div> 
            </div>
            <div style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
              <div style="display: flex; flex: 1; align-items: center; justify-content: center;">
                  <div style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;">
                      <span class="glow" ref="myBtn">
                      {{loadingtext}}
                      </span>
                  </div>
                </div> 
            </div>
          <div style="position: absolute; top: 90px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
              <lottie :options="defaultOptions2" :height="300" :width="300" v-on:animCreated="handleAnimation2"/>
          </div>
          <div style="position: absolute; top: 90px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;" @click="openGift">
            <lottie :options="defaultOptions" :height="300" :width="300" v-on:animCreated="handleAnimation"/>
          </div>
          
          <div style="position: absolute; bottom: 50px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
            <lottie :options="defaultOptionsSanta" :height="300" :width="300" v-on:animCreated="handleAnimationSanta"/>
          </div>
      </div>
    </div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import Lottie from './lottie.vue';
import { loadAnimation } from '@/services/lottieLoader';
import liffService from "@/services/liff";
const audio2 = new Audio(require('../assets/santa_mix.mp3'));
// @ is an alias to /src
export default {
  name: "Santaclaus",
  async created() {
    document.body.style.backgroundColor = '#9CD0DF'
    const [animate, animateOpenBox, animateSanta, animateSplashScreen] = await Promise.all([
      loadAnimation('Coins_Box'),
      loadAnimation('open_coins_box5'),
      loadAnimation('Santa'),
      loadAnimation('SantaWalk')
    ]);
    this.defaultOptions = {animationData: animate,autoplay:false,loop:true};
    this.defaultOptions2 = {animationData: animateOpenBox,autoplay:false,loop:false};
    this.defaultOptionsSanta = {animationData: animateSanta,autoplay:false,loop:true};
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  mounted() {
    // LIFF is already initialized by router guard
    this.loadUserData();
    // Animation logic moved to handleAnimationSplashScreen
  },
  components: {
    'lottie': Lottie
  },
  data() {
    return {
      showLoading:true,
      loadingtext:'น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่',
      displayName: "",
      //email: "",
      userId: "",//Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      isDisabled: true,
      loading: true,
      error: "",
      mycoin:0,
      userKey:'',
      defaultOptions: null,
      defaultOptions2: null,
      openGiftData:false,
      canOpen:false,
      credit:50
    };
  },
  methods: {
    async openGift(){
        if(this.canOpen){
          this.anim.stop();
          this.anim.hide();
          this.anim2.show();
          this.anim2.play();
          await firebase.firestore().collection('santaclaus').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).set({
            userId:this.userId,
            createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
            value:this.credit
          });
          setTimeout(() => {
            this.$confirm(
              {
                message: `🎁 ปังปุรีเย่!! คุณได้รับ ${this.credit} เครดิต😘😘`,
                button: {
                yes: 'OK'
                },
                callback: async (confirm) => {
                  if (confirm) {
                    this.sendMessageLine(`ปังปุรีเย่!! คุณได้รับ ${this.credit} เครดิต😘😘\nโปรดรอสักครู่น้องออโต้กำลังจัดการให้อยู่ค่ะ😘😘`);
                  }
                }
              }
            );
          }, 2000);
        } 
    },
    handleAnimationSplashScreen: function (anim) {
      this.animSplashScreen = anim;
      this.animSplashScreen.play();
      setTimeout(() => {
        this.showLoading = false;
        this.animSplashScreen.stop();
        setTimeout(() => {
          audio2.volume = 0.6;
          audio2.play();
          if (this.anim) this.anim.play();
          if (this.animSanta) this.animSanta.play();
          if (this.anim2) this.anim2.hide();
        }, 500);
      }, 3500);
    },
    handleAnimation: function (anim) {
        this.anim = anim;
    },
    handleAnimation2: function (anim2) {
        this.anim2 = anim2;
    },
    handleAnimationSanta: function (anim){
        this.animSanta = anim;
    },
    async sendMessageLine(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🎁 "+text,
          },
      ]);
      window.liff.closeWindow();
    },
    async sendMessageLine2(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🎁 "+text,
          },
      ]);
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (!window.liff.isInClient()) {
          router.replace("/login");
      }else{
          this.displayName = profile.displayName ? profile.displayName : "none";
          this.statusMessage = profile.statusMessage
            ? profile.statusMessage
            : "none";
          if (this.userId) {
              const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
              if (user) {
                  const u = user[Object.keys(user)[0]];
                  this.mycoin = (u.coins)?u.coins:0;
                  this.userKey = Object.keys(user)[0];
                  this.sendMessageLine2("สนใจรับของขวัญจากแซนต้า 😘😘");
                  const currentDate = moment().tz("Asia/Bangkok");
                  const currentDay = currentDate.date();
                  const currentMonth = currentDate.month() + 1; // moment month is 0-indexed
                  const currentYear = currentDate.year();
                  
                  if(currentYear === 2025 && currentMonth === 12 && (currentDay === 24 || currentDay === 25 || currentDay === 26)) {
                    await firebase.firestore().collection('santaclaus').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then(async (snapshot) => {
                      if(snapshot.exists) {
                          this.sendMessageLine("ลูกค้ารับของขวัญจากแซนต้าไปแล้วนะคะ 😘😘");
                      }else{
                        await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 15:00:00').get().then(async (snapshot) => {
                          let credit = 0;
                          snapshot.forEach((doc)=>{
                            credit += Number(doc.data().qty);
                          });
                          if(credit >= 300){
                            this.loadingtext = '🎅 แซนต้าพร้อมแล้ว เปิดของขวัญได้เลยค่ะ😘😘';
                            this.canOpen = true;
                            //can open
                          }else{
                            const less = 300-Number(credit);
                            this.loadingtext = `เติมเงินอีก ${less} เปิดของขวัญได้เลยค่ะ!😘😘`;
                          }
                        });
                      }
                    });
                    // this.loadingtext = '🎅 แซนต้าพร้อมแล้ว เปิดของขวัญได้เลยค่ะ😘😘';
                    // this.canOpen = true;
                  }else{
                     this.loadingtext = `กิจกรรมนี้เฉพาะวันที่ 24-26 ธันวาคม เท่านั้น!😘😘`;
                  }
              }else{
                router.replace("/register");
              }
            this.isDisabled = false;
          }
      }
    },
  }
};
</script>
<style scoped>
.glow {
            color: #fff;
            text-align: center;
            -webkit-animation: glow 1s ease-in-out infinite alternate;
            -moz-animation: glow 1s ease-in-out infinite alternate;
            animation: glow 1s ease-in-out infinite alternate;
            }

            @-webkit-keyframes glow {
            from {
                text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
            }
            
            to {
                text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
            }
        }
.spin {   padding: 0px;
          margin: 0px;
          overflow: hidden;
          height: 100%;
          width: 100%;
          position: absolute;
/*background: rgb(255,204,92,1);
background: radial-gradient(circle, rgba(255,204,92,1) 49%, rgba(34,193,195) 100%);*/
          background: linear-gradient(#0089c6,#95e9fd);
          border-right: 2px solid #cbcbcb;
          /*background-image: url("../assets/images/favpng_christmas-tree_VdCkevwg.png");
          background-position: center; /* Center the image */
          background-repeat: no-repeat; /* Do not repeat the image */
          background-size: cover; 
      }
      .center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
        padding-top: 50%;
        height: 100%;
      }
</style>